import { Avatar, Badge, Button, Popconfirm, Tag, Tooltip } from "antd";
import { Trash2 } from "lucide-react";
import { format } from "date-fns";
import { getPascalCase } from "helpers/common.helper";

export function getTeamColumns({ onRevoke, revokingId }) {
  return [
    {
      title: "",
      key: "avatar",
      align: "center",
      render: (_, r) => (
        <Tooltip title={r.has_active_session ? "Currently logged in" : ""}>
          <Badge dot={r.has_active_session} color="green" offset={[-2, 4]}>
            <Avatar size={32}>{r.name?.[0]?.toUpperCase()}</Avatar>
          </Badge>
        </Tooltip>
      ),
    },
    {
      title: "Member",
      key: "member",
      align: "center",
      render: (_, r) => (
        <p className="font-medium text-sm">{getPascalCase(r.name)}</p>
      ),
    },
    {
      title: "Status",
      key: "status",
      align: "center",
      render: (_, r) =>
        r.has_active_session ? (
          <Tag color="green">Logged in</Tag>
        ) : (
          <Tag>Offline</Tag>
        ),
    },
    {
      title: "Phone",
      key: "phone",
      align: "center",
      render: (_, r) => (
        <p className="text-xs text-muted-foreground">{r.phone_number}</p>
      ),
    },
    {
      title: "Added On",
      key: "added_on",
      align: "center",
      render: (_, r) =>
        r.audit?.created_at &&
        format(new Date(r.audit.created_at), "MMM d, yyyy"),
    },
    {
      title: "",
      key: "action",
      align: "right",
      width: 100,
      render: (_, r) => (
        <Popconfirm
          title="Revoke access?"
          description="This person will be signed out immediately and can no longer manage this account."
          okText="Revoke"
          okButtonProps={{ danger: true }}
          cancelText="Cancel"
          onConfirm={() => onRevoke(r.member_id)}
        >
          <Button
            danger
            type="text"
            size="small"
            icon={<Trash2 className="h-4 w-4" />}
            loading={revokingId === r.member_id}
          >
            Revoke
          </Button>
        </Popconfirm>
      ),
    },
  ];
}
